import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  Event_Participant_Table_data: {
    columns : [
      {
        label: 'First Name',
        field: 'FirstName',
        sort: 'asc'
      },
      {
        label: 'Last Name',
        field: 'LastName',
        sort: 'asc'
      },
      {
        label: 'Phone',
        field: 'Phone',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'Email',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'Action',
        sort: 'asc'
      },
    ]
  },
  Checked_Participant_Table_data: {
    columns : [
      {
        label: 'First Name',
        field: 'FirstName',
        sort: 'asc'
      },
      {
        label: 'Last Name',
        field: 'LastName',
        sort: 'asc'
      },
      {
        label: 'Phone',
        field: 'Phone',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'Email',
        sort: 'asc'
      },
      {
        label: 'Checked In Time',
        field: 'checkedInTime',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }
    ]
  }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.DISPLAY_APPROVE_PARTICIPANT:
        return {
          ...state,
          participantApproved:  state.participantApproved.concat(action.data),
          participantPending: [...state.participantPending.filter(aparticipant => aparticipant !== action.data)]
        };
        case actionTypes.DECLINE_PARTICIPANT:
          const index = action.dataD.index
          return {
            ...state,
            participantPending: [...state.participantPending.filter(rparticipant => rparticipant !== action.dataD)]
          };
      default:
        return state;
    }
  };

export default reducer;
